export { default } from "./decorated-image"